import { Product } from './products'

/** Big Green Egg accessories currently listed in the Pegasus online catalog. */
export const bigGreenEggProducts: Product[] = [
  {
    name: 'Plancha Griddle – Half Moon',
    sku: '12872',
    price: 46.0,
    availability: 'Out of Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Big%20Green%20Egg/half-moon-griddle-lg-800sq.jpg400x400.jpg',
    alt: 'Half moon plancha griddle for a Big Green Egg',
  },
  {
    name: 'Bamboo Grill Skewers',
    sku: '11070',
    price: 2.49,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Big%20Green%20Egg/41hXbkXtn5L.jpg400x400.jpg',
    alt: 'Package of bamboo grill skewers',
  },
  {
    name: '20# Lump Charcoal',
    sku: '13694',
    price: 24.95,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Big%20Green%20Egg/Charcoal.jpg400x400.jpg',
    alt: 'Twenty pound bag of natural lump charcoal',
  },
  {
    name: 'Extended Racks – 3 Level Cooking Grid',
    sku: '15721',
    price: 87.0,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Big%20Green%20Egg/3-Tier-Grid-800px.jpg400x400.jpg',
    alt: 'Three level extended cooking grid rack',
  },
  {
    name: 'Enameled Cast Iron Dutch Oven – Round',
    sku: '12910',
    price: 79.95,
    availability: 'Out of Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Big%20Green%20Egg/enameled-cast-iron-round-dutch-oven-800sq.jpg400x400.jpg',
    alt: 'Round enameled cast iron dutch oven with lid',
  },
  {
    name: 'Enameled Cast Iron Dutch Oven – Oval',
    sku: '12909',
    price: 139.95,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Big%20Green%20Egg/enameled-cast-iron-oval-dutch-oven-800sq.jpg400x400.jpg',
    alt: 'Oval enameled cast iron dutch oven with lid',
  },
  {
    name: 'Cast Iron Fire Grate for a Large or MiniMax EGG',
    sku: '12693',
    price: 20.45,
    availability: 'Out of Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Big%20Green%20Egg/fire-grate-800sq.jpg',
    alt: 'Cast iron fire grate for a Big Green Egg',
  },
  {
    name: 'Dual Function Metal Top',
    sku: '12707',
    price: 47.0,
    availability: 'Out of Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Big%20Green%20Egg/daisy-wheel-800sq-600x600.jpg',
    alt: 'Dual function metal top vent for a Big Green Egg',
  },
]
